import styled from 'styled-components'

const FilteredInput = styled.input`
  border: 1px solid #aaa;
  border-radius: 100px;
  padding: 0.4rem 1rem .4rem 2.6rem;
  margin: .5rem 0;
  font-size: inherit;
  width: 100%;
  color: inherit;
`

export default FilteredInput